import { useMemo } from 'react'

import {
  Box,
  Icon,
  IconsName,
  Text,
  ThemeColors,
} from '@fairfashion/design-system'

import { docMask } from '../../../utilities/masks/brasilianDocuments'

import * as Styles from './order-production-item.styles'
import { OrderProductionItemProps } from './order-production-item.types'

export const OrderProductionItem = ({
  orderProductionItem,
}: OrderProductionItemProps) => {
  // Internal Step
  if (!orderProductionItem.provider) {
    return (
      <Box direction="column" gap={2} flex={1} width="100%">
        <Box gap={2} alignItems="center" flex={1}>
          <Styles.IconContainer>
            <Icon name="building3" color="lilac" size={24} />
          </Styles.IconContainer>
          <Text fontWeight={500}>Produção interna</Text>
        </Box>

        <Box gap={4} flexWrap="wrap" width="100%">
          <Styles.Column>
            <Styles.Title>Código</Styles.Title>
            <Styles.Value>{orderProductionItem.code}</Styles.Value>
          </Styles.Column>
          <Styles.Column>
            <Styles.Title>Descrição do material</Styles.Title>
            <Styles.Value>{orderProductionItem.description}</Styles.Value>
          </Styles.Column>
          <Styles.Column>
            <Styles.Title>Quantidade</Styles.Title>
            <Styles.Value>{`${orderProductionItem.quantity} ${orderProductionItem.taxUnit}`}</Styles.Value>
          </Styles.Column>
        </Box>
      </Box>
    )
  }

  const { title, color, provider, icon } = useMemo(() => {
    if (orderProductionItem.sender === 'provider') {
      return {
        title: 'Recebido do fornecedor',
        color: 'light_purple',
        provider: `${orderProductionItem.provider?.name} - ${docMask(orderProductionItem.provider?.taxId ?? '')}`,
        icon: 'arrow_left_circle',
      }
    }

    return {
      title: 'Enviado para o fornecedor',
      color: 'light_blue',
      provider: `${orderProductionItem.client?.name} - ${docMask(orderProductionItem.client?.taxId ?? '')}`,
      icon: 'arrow_right_circle',
    }
  }, [orderProductionItem])

  return (
    <Box direction="column" gap={2}>
      <Box gap={2} alignItems="center">
        <Styles.IconContainer>
          <Icon
            name={icon as IconsName}
            color={color as ThemeColors}
            size={24}
          />
        </Styles.IconContainer>
        <Text fontWeight={500}>{title}</Text>
      </Box>

      <Box gap={4} flexWrap="wrap">
        <Styles.Column flex={4}>
          <Styles.Title>Fornecedor</Styles.Title>
          <Styles.Value>{provider}</Styles.Value>
        </Styles.Column>
        <Styles.Column flex={1}>
          <Styles.Title>Código</Styles.Title>
          <Styles.Value>{orderProductionItem.code}</Styles.Value>
        </Styles.Column>
        <Styles.Column flex={1}>
          <Styles.Title>Descrição do material</Styles.Title>
          <Styles.Value>{orderProductionItem.description}</Styles.Value>
        </Styles.Column>
        <Styles.Column flex={1}>
          <Styles.Title>Quantidade</Styles.Title>
          <Styles.Value>{`${orderProductionItem.quantity} ${orderProductionItem.taxUnit}`}</Styles.Value>
        </Styles.Column>
      </Box>
    </Box>
  )
}
